import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=496b8aca&lang=pug&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496b8aca')) {
      api.createRecord('496b8aca', component.options)
    } else {
      api.reload('496b8aca', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=496b8aca&lang=pug&", function () {
      api.rerender('496b8aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/prototype/confirm.vue"
export default component.exports